import React from 'react'
import { buildQuery } from '../graphql'
import { useContext } from './Context'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import type { SetOptional } from 'type-fest'

export type BoardInlineInputProps = SetOptional<InlineInputProps, 'initialValues' | 'mutationConfig'> & {
  queryName?: string
}

export const BoardInlineInput = ({
  parentInputComponent,
  initialValues,
  mutationConfig,
  queryName,
  name,
  ...rest
}: BoardInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  const { document } = useContext()
  initialValues = initialValues || document

  const autoMutationConfig = React.useMemo(() => {
    if (queryName) return buildQuery(queryName).updateConfig
    return buildQuery(name).updateConfig
  }, [name, queryName])
  mutationConfig = mutationConfig || autoMutationConfig

  return <ParentInput {...{ initialValues, mutationConfig, name, ...rest }} />
}
